import type { ReactNode } from "react";

import { Box, VStack } from "@chakra-ui/react";

import { Button } from "@shared/ui/chakra/buttons/button";
import { Typography } from "@shared/ui/chakra/typography/typography";

type Props = {
  buttonText: ReactNode;
  iconSlot?: ReactNode;
  subtitle: ReactNode;
  title: ReactNode;
  onAction?: () => void;
};

export const EmptyState = ({
  buttonText,
  iconSlot,
  subtitle,
  title,
  onAction,
}: Props) => {
  return (
    <VStack alignItems="center" gap="24px">
      <Box
        alignItems="center"
        bgColor="bg.subtle"
        borderRadius="50%"
        display="flex"
        h="96px"
        justifyContent="center"
        w="96px"
      >
        {iconSlot}
      </Box>
      <VStack alignItems="center" gap="12px" justifyContent="center">
        <Typography textAlign="center" textStyle="h4">
          {title}
        </Typography>
        <Typography textAlign="center" textStyle="body2">
          {subtitle}
        </Typography>
      </VStack>
      <Button w="full" onClick={onAction}>
        {buttonText}
      </Button>
    </VStack>
  );
};
